<div class="row" *ngFor="let item of UploadFileData; let i = index;">


<div class="col-sm-12">
    <div class="form-group row text-left">
        <label for="lblChoosefile" *ngIf="!FromView" class="col-sm-3 col-form-label">Choose file
                </label>
        <div class="col-sm-8">
            <div class="input-group">
                
                
                <div class="custom-file col-sm-6" *ngIf="!FromView" >                    
                    <label class="custom-file-label"  *ngIf="item.File== undefined">Choose file </label>
                    <label class="custom-file-label"  *ngIf="item.File!= undefined">{{item.File?.name}}</label>
                    <input type="file" class="custom-file-input" [disabled]="item.disable" (change)="selectFiles(item,$event,i)" id="fileUpload">
                </div>
                
                <input type="text"class="form-control col-sm-5 ml-2" *ngIf="!FromView" placeholder="Document Name" id="txtDocumentName" name="txtDocumentName" [(ngModel)]="item.Purpose" placeholder="Documnet Purpose">
                <input type="text"class="form-control col-sm-5 ml-2" *ngIf="FromView" [disabled]="item.disable" placeholder="Document Name" id="txtDocumentName" name="txtDocumentName" [(ngModel)]="item.Purpose" placeholder="Documnet Purpose">
                <i *ngIf="mode=='U'" (click)="Download(item)" class="col-sm-1 fa fa-download fa-2x"></i>
            </div>

        </div>
        <!-- FromView added by rahul yadav on 15/7/2021 in case of view -->
        <div class="col-sm-1" *ngIf="item.IsNewRow && !FromView " (click)="deleteRow(i,item)">
            <i class="fa fa-trash fa-2x"></i>
        </div>
        <div class="col-sm-1" *ngIf="!item.IsNewRow && !FromView" (click)="addRow(item,i)">
            <i class="fa fa-plus fa-2x"></i>
        </div>
    </div>
</div>





</div>


<div class="row">
    
<!-- <div class="col-sm-12">
    <button class="btn btn-success"  (click)="uploadFiles()" type="button">upload</button>
    </div> -->
    
    <div class="col-sm-12" *ngIf="progressInfos.length>0">
        <div *ngFor="let progressInfo of progressInfos" class="mb-2">
            <span>{{ progressInfo.fileName }}</span>
            <div class="progress">
                <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                    attr.aria-valuenow="{{ progressInfo.value }}" aria-valuemin="0" aria-valuemax="100"
                    [ngStyle]="{ width: progressInfo.value + '%' }">
                    {{ progressInfo.value }}%
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-sm-12">
        <div class="alert alert-light" role="alert">{{ message }}</div>
    </div>
</div>